module.exports = __webpack_public_path__ + "assets/ib_logo.88ef45dabda5b2bbe32eb13597007f28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ib_logo.png
// module id = 90
// module chunks = 0